import { NavatticTutorial } from './navattic.types';

/**
 * True when a tutorial record exists but has no embed URL — GrowthBook misconfiguration.
 * Not true when tutorial is null (user ineligible / wrong variant / no match).
 */
export function isNavatticTutorialMissingTourUrl(
  tutorial: NavatticTutorial | null | undefined,
): boolean {
  return tutorial != null && !tutorial.tourUrl;
}
